/**
 * Main application entry point.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var app = require('mag-app');

app.once('load', function () {
    app.pages = {
        init: require('./pages/main')
    };
    app.route(app.pages.init);
    app.ready();
});
